import firebase from "../../Config/firebase";
import React, {Component} from "react";
import Compressor from "compressorjs";
import {v4 as uuidv4} from "uuid";
import {Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Label, Row} from "reactstrap";
import classes from "./NewArticle.module.css";
import ReactQuill from "react-quill";
import AsyncSelect from "react-select/async/dist/react-select.esm";
import {Link, withRouter} from "react-router-dom";
import {MDBCol, MDBContainer, MDBRow, MDBCard, MDBCardBody, MDBBreadcrumb, MDBBreadcrumbItem, MDBAlert} from "mdbreact";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";

import ReactQuillEditorCss from '../../Utils/ReactQuillEditor.module.css'
import common from '../../Utils/common.module.css'
import {isEmpty} from "react-redux-firebase";

const db = firebase.firestore()
const storageRef = firebase.storage()

class NewArticle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            community: {},
            article: {
                title: '',
                content: '',
                createDate: new Date(),
                featureImage: '',
                isPublish: false,
                lastModified: new Date(),
                createUserID: '',
                communityID: ''
            },
            hasFeatureImage: false,
            isEmpty: false
        }
    }

    modules = {
        toolbar: {
            container: [[{'header': [1, 2, false]}],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
                ['link', 'image'],
                ['clean'], ['code-block']
            ],
            handlers: {
                'image': () => this.quillImageCallBack()
            },
            clipboard: {
                matchVisual: false
            }
        }
    }

    formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image'
    ]

    // componentDidMount() {
    //     if(typeof this.props.location.state !== 'undefined'){
    //         this.setState({
    //                 post: {
    //                     ...this.state.post,
    //                     communityID:this.props.location.state.community.communityID
    //                 }
    //             }, () =>{
    //                 console.log(this.state.post)}
    //         )
    //     }
    // }
    //
    // componentWillReceiveProps(nextProps, nextContext) {
    //     if(this.props !== nextProps){
    //         console.log(nextProps)
    //     }
    // }

    onChangeArticleTitle = (value) => {
        this.setState({
            article: {
                ...this.state.article,
                title: value
            }
        })
    }

    onChangeArticleContent = (value) => {
        this.setState({
            article: {
                ...this.state.article,
                content: value
            }
        })
    }

    onChangePublish = (val) => {
        this.setState({
            article: {
                ...this.state.article,
                isPublish: val === "True"
            }
        })
    }

    submitArticle = () => {
        const article = this.state.article
        if (article.title !== '' && article.content !== '') {
            db.collection('Article')
                .add(article)
                .then(res => {
                    console.log(res)
                    article.id = res.id
                    this.props.history.push({
                        pathname: '/article/' + res.id,
                        state: {article: article}
                    })
                })
                .catch(err => console.log(err))
        } else {
            this.setState({
                isEmpty: true
            })
        }
    }

    fileCompress = (file) => {
        return new Promise((resolve, reject) => {
            console.log(file)
            new Compressor(file, {
                file: 'File',
                quality: 0.5,
                maxWidth: 640,
                maxHeight: 640,
                success(file) {
                    return resolve({
                        success: true,
                        file: file
                    })
                },
                error(err) {
                    return resolve({
                        success: false,
                        message: err.message
                    })
                }
            })
        })
    }

    featureImageCompress = (file) => {
        return new Promise((resolve, reject) => {
            console.log(file)
            new Compressor(file, {
                file: 'File',
                quality: 0.5,
                maxWidth: 1200,
                maxHeight: 628,
                success(file) {
                    return resolve({
                        success: true,
                        file: file
                    })
                },
                error(err) {
                    return resolve({
                        success: false,
                        message: err.message
                    })
                }
            })
        })
    }

    quillImageCallBack = () => {
        const input = document.createElement('input')
        input.setAttribute('type', 'file')
        input.setAttribute('accept', 'image/*')
        input.click()
        input.onchange = async () => {
            const file = input.files[0]
            const compressState = await this.fileCompress(file)
            if (compressState.success) {
                const fileName = uuidv4()
                storageRef.ref().child('Article/' + fileName).put(compressState.file)
                    .then(async snapshot => {
                        const downloadURL = await storageRef.ref().child('Article/' + fileName).getDownloadURL()
                        console.log(downloadURL)
                        let quill = this.quill.getEditor()
                        const range = quill.getSelection(true)
                        quill.insertEmbed(range.index, 'image', downloadURL)
                    })
            }
        }
    }

    uploadImageCallBack = (e) => {
        return new Promise(async (resolve, reject) => {
            const file = e.target.files[0]
            const compressState = await this.featureImageCompress(file)
            if (compressState.success) {
                const fileName = uuidv4()
                storageRef.ref().child('Article/' + fileName).put(compressState.file)
                    .then(async snapshot => {
                        const downloadURL = await storageRef.ref().child('Article/' + fileName).getDownloadURL()
                        console.log(downloadURL)
                        resolve({
                            success: true,
                            data: {link: downloadURL}
                        })
                    })
            }
        })
    }


    render() {
        return (
            <MDBContainer>


                <MDBRow>
                    <MDBCol xl={12} lg={12} md={12} sm={12} xs={12}>
                        <h2 className={classes.SectionTitle}>新增文章</h2>
                        {
                            this.state.isEmpty ?
                                <MDBAlert color='danger'>
                                    請填寫標題及內容
                                </MDBAlert>
                                : ''
                        }
                    </MDBCol>
                </MDBRow>
                <MDBRow>
                    <MDBCol xl={9} lg={9} md={8} sm={12} xs={12}>
                        <MDBCard className={classes.AritlceContainer}>
                            <MDBCardBody>
                                <FormGroup>
                                    <Label className={classes.Label}>Title</Label>
                                    <Input type='text' name='articleTitle' id='articleTitle' placeholder=''
                                           onChange={(e) => {
                                               this.onChangeArticleTitle(e.target.value)
                                               this.setState({
                                                   isEmpty: false
                                               })
                                           }}
                                           value={this.state.article.title}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <div className={ReactQuillEditorCss.ReactQuillEditor}>
                                        <ReactQuill
                                            ref={(el) => this.quill = el}
                                            value={this.state.article.content}
                                            onChange={(e) => {
                                                this.onChangeArticleContent(e)
                                                this.setState({
                                                    isEmpty: false
                                                })
                                            }}
                                            theme='snow'
                                            modules={this.modules}
                                            formats={this.formats}
                                        />
                                    </div>
                                </FormGroup>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                    <MDBCol xl={3} lg={3} md={4} sm={12} xs={12}>
                        <Card>
                            <CardHeader>
                                Article Setting
                            </CardHeader>
                            <CardBody>
                                <FormGroup>
                                    <Label className={classes.Label}>Publish</Label>
                                    <Input type='select' name='publish' id='publish'
                                           onChange={(e) => this.onChangePublish(e.target.value)}>
                                        <option>False</option>
                                        <option>True</option>
                                    </Input>
                                </FormGroup>
                                <FormGroup>
                                    <Label className={classes.Label}>Feature Image</Label>
                                    <Input type='file' accept='image/*' onChange={async (e) => {
                                        const uploadState = await this.uploadImageCallBack(e)
                                        if (uploadState.success) {
                                            this.setState({
                                                hasFeatureImage: true,
                                                article: {
                                                    ...this.state.article,
                                                    featureImage: uploadState.data.link
                                                }

                                            })
                                            console.log(uploadState.data.link)
                                        }
                                    }}>
                                    </Input>

                                    {
                                        this.state.hasFeatureImage ?
                                            <img src={this.state.article.featureImage} className={classes.FeatureImg}/>
                                            : ''
                                    }
                                </FormGroup>

                                <FormGroup>
                                    <Button color='danger'
                                            onClick={(e) => this.submitArticle()}>
                                        Submit
                                    </Button>
                                </FormGroup>
                            </CardBody>
                        </Card>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        )
    }
}

export default withRouter(NewArticle)